/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


/* ==================================================================
 * SEARCH: include pages alongside products
 *
 * Two separate problems, both caused by the theme asking Shopify for
 * products only. The Search & Discovery app settings cannot override
 * either of them, because the theme never requests the other types.
 *
 * See snippets/search-type-note.liquid for the full write-up.
 * ================================================================== */

/* ------------------------------------------------------------------
 * 1. Predictive search (the dropdown under the search bar).
 *
 * theme.js calls /search/suggest?section_id=predictive-search&... with
 * no resources[type] parameter. Shopify's Predictive Search API then
 * defaults to products only. sections/predictive-search.liquid already
 * knows how to render collections, pages and articles - it just never
 * receives any.
 *
 * Wrap fetch and add the parameter to that one request. Anything
 * unexpected falls through to the original fetch untouched, so search
 * can never break because of this.
 * ------------------------------------------------------------------ */
(function () {
  var RESOURCE_TYPES = 'product,collection,page';
  var nativeFetch = window.fetch;

  if (typeof nativeFetch !== 'function') {
    return;
  }

  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url);

      if (
        url &&
        url.indexOf('section_id=predictive-search') !== -1 &&
        url.indexOf('resources[type]') === -1 &&
        url.indexOf('resources%5Btype%5D') === -1
      ) {
        var patchedUrl = url + '&resources[type]=' + RESOURCE_TYPES;

        if (typeof input === 'string') {
          input = patchedUrl;
        } else {
          input = new Request(patchedUrl, input);
        }
      }
    } catch (error) {
      /* Leave the request untouched if anything unexpected happens. */
    }

    return nativeFetch.call(this, input, init);
  };
})();


/* ------------------------------------------------------------------
 * 2. The header search form.
 *
 * sections/header.liquid hardcodes <input name="type" value="product">,
 * so submitting the search bar goes to /search?type=product and pages
 * are excluded server-side.
 *
 * sections/main-search.liquid was edited directly to request
 * type=product,page. The header form is patched here instead, so that
 * header.liquid stays byte-identical to the stock theme and is easy to
 * diff on the next theme update. If that file is ever edited to send
 * product,page itself, this block becomes a harmless no-op.
 * ------------------------------------------------------------------ */
(function () {
  var SEARCH_TYPES = 'product,page';

  function applySearchTypes() {
    var inputs = document.querySelectorAll('form[action*="search"] input[name="type"][value="product"]');

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].value = SEARCH_TYPES;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySearchTypes);
  } else {
    applySearchTypes();
  }

  /* The header can be re-rendered by the theme editor or by section
     reloads, so re-apply when that happens. */
  document.addEventListener('shopify:section:load', applySearchTypes);
})();
